import React from 'react';
import { Circle, G, Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';

export interface GoogleCalendarIconProps extends SvgProps {
  size?: number;
}

export const GoogleCalendarIcon: React.FC<GoogleCalendarIconProps> = ({
  size = 64,
  ...props
}) => {
  // Scale the Google icon (18x18) to fit nicely in the circle
  const iconSize = size * 0.45; // 45% of circle size
  const scale = iconSize / 18;
  // Circle center
  const centerX = 32;
  const centerY = 32;
  // The icon is 18x18, center is at (9, 9)
  // Original SVG transform: matrix(1,0,0,-1,.899902,17.100586)
  // Strategy: translate to center, scale, flip, then apply original offset
  // But we need to account for the offset when centering
  const iconCenter = 9;
  const originalOffsetX = 0.899902;
  const originalOffsetY = 17.100586;

  return (
    <Svg width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
      {/* Blue circle background */}
      <Circle cx="32" cy="32" r="32" fill="#4285F4" />
      {/* Google G icon - scaled and centered */}
      <G
        transform={`translate(${centerX}, ${centerY}) scale(${scale}, -${scale}) translate(${-iconCenter}, ${iconCenter}) translate(${originalOffsetX}, ${-originalOffsetY})`}
      >
        <Path
          d="M11.460878 11.862177C10.863914 12.411216 9.816997 13.068213 8.26498 13.068213 6.079596 13.068213 4.224729 11.655603 3.554015 9.703043L3.554052 9.702183C3.388746 9.198189 3.287764 8.658209 3.287764 8.100174 3.287764 7.542202 3.388745 7.00216 3.563232 6.498167L3.562862 6.497887C4.224266 4.545078 6.07926 3.1323 8.264823 3.1323 9.495412 3.1323 10.432171 3.465299 11.130118 3.942306L11.130469 3.942039 11.130522 3.942383C12.232585 4.698342 12.728502 5.823346 12.820304 6.570371H8.265235V9.576338H16.025448C16.144789 9.072344 16.199934 8.586344 16.199934 7.920351 16.199934 5.454363 15.299899 3.375352 13.738701 1.962335L13.73811 1.962393 13.738304 1.962245C12.369886 .720278 10.496431 .000238 8.264823 .000238 5.032131 .000238 2.240278 1.818299 .881104 4.464295L.881296 4.46482C.321311 5.562678 0 6.795423 0 8.100174 0 9.405106 .321399 10.63807 .881526 11.736042L.881285 11.736225C2.240455 14.382208 5.032299 16.200196 8.26498 16.200196 10.496582 16.200196 12.360913 15.399191 13.793524 14.094193L11.460878 11.862177Z"
          fill="#FFFFFF"
          fillRule="evenodd"
        />
      </G>
    </Svg>
  );
};

GoogleCalendarIcon.displayName = 'GoogleCalendarIcon';
